import { EntityRequestRemote } from "../../entity/EntityRequestRemote";

export class DtoRequestRemotesDeleteRes extends EntityRequestRemote {
  public message: string | null = null;
}
